export class ApplicationColor {
    TopNavBackgroundColor: string;
    TopNavForegroundColor: string;
      CtaBackgroundColor: string;
    CtaFontColor: string;
    Theme: string | undefined;

    constructor(topNavBackgroundColor: string, topNavForegroundColor: string,ctaBackgroundColor: string, ctaFontColor: string, theme?: string) {
        this.TopNavBackgroundColor = topNavBackgroundColor;
        this.TopNavForegroundColor = topNavForegroundColor;
        this.CtaBackgroundColor = ctaBackgroundColor;
        this.CtaFontColor = ctaFontColor;
        this.Theme = theme; // Can be undefined or a string
    }
}
